import React from 'react';
import { Outlet } from 'react-router-dom';
export const LoginLayout = () => {
    return (<div className=' min-h-screen bg-blue-50'>
        <div className="min-h-screen flex items-center justify-center w-full lg:max-w-full lg:flex">
            <Outlet />
        </div>
    </div>)
}
